export enum UploadFolder {
  ORGANIZATION_LOGOS = 'organization_logos',
  PROFILE_PICTURES = 'profile_pictures'
}
